import { Typography, Link } from '@mui/material'

export const pageContent = {
  pageTitle: 'Clearscore January exclusive giveaway Terms and Conditions ',
  sections: [
    {
      title: 'The Prize Draw',
      content: (
        <Typography variant="body1">
          <strong>The Prize Draw</strong>. This prize draw (the <strong>“Prize Draw”</strong>) is
          being promoted by Zuto Limited (<strong>“Zuto”</strong>)), a company registered in England
          and Wales with registration number 05722976 and whose registered office is at Winterton
          House, Winterton Way, Macclesfield, Cheshire, SK11 0LP.
        </Typography>
      )
    },
    {
      title: 'Prize Draw Period',
      content: (
        <Typography variant="body1">
          <strong>Prize Draw Period</strong>. This Prize Draw starts at 00:00 on 1 January 2026 and
          closes at 23:59 on 31 January 2026 (<strong>“Prize Draw Period”</strong>). Eligible
          Customers must submit their finance application by clicking “Apply Now” on any “Zuto” or
          “powered by Zuto” product tile on the ClearScore website by 23:59 on 31 January 2026 and
          the finance agreement must not have been cancelled or terminated and have been in place
          for at least 60 days by 23:59 on 15 April 2026. Applications made via any other channel or
          campaign will not be entered into the Prize Draw.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          The Prize Draw is open to all UK residents aged 18 years or over except employees of Zuto,
          their families, agents or any third party directly associated with administration of the
          Prize Draw.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          All customers who meet the eligibility criteria will be automatically entered into the
          Prize Draw unless they expressly inform Zuto that they do not wish to be included in the
          Prize Draw by emailing <Link href="mailto:crm@zuto.com">crm@zuto.com</Link> (providing
          your full name and the email address associated with your application) (
          <strong>“Opt-out”</strong>). Unless you Opt-out, you agree to be bound by these terms and
          conditions.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          If there is any inconsistency between these terms and conditions and any other terms
          published by Zuto, these terms and conditions prevail. Zuto reserves the right to refuse
          entry to the Prize Draw or refuse to award the Prize to anyone in breach of these terms
          and conditions.
        </Typography>
      )
    },
    {
      content: <Typography variant="body1">One entry per Eligible Customer.</Typography>
    },
    {
      content: (
        <Typography variant="body1">
          Thirty (30) winners will be selected from all valid entries received from Eligible
          Customers (as defined below) by a random draw performed by a computer process on 16 April
          2026 (the <strong>“Winner(s)”</strong>). Each winner will receive £1,000 (one thousand
          pounds) in cash (<strong>“Prize”</strong>).
        </Typography>
      )
    },
    {
      title: 'Eligibility',
      content: (
        <div>
          <Typography variant="body1">
            <strong>Eligibility</strong>. Entry to the Prize Draw is open to Zuto customers who:
          </Typography>
          <ul>
            <li>
              complete a finance application by clicking “Apply now” or “Continue to application” on
              any “Zuto” or “powered by Zuto” product tile on the ClearScore website by 23:59 on 31
              January 2026;
            </li>
            <li>are permanent residents of the United Kingdom;</li>
            <li>are not operating any fraudulent ClearScore accounts;</li>
            <li>
              are approved for finance through Zuto on or prior to 31 January 2026 and have taken
              out a finance product brokered by Zuto, with funds released by the lender; and
            </li>
            <li>
              have entered into a finance agreement which has not been cancelled or terminated and
              has been in place for at least 60 days by 23:59 on 15 April 2026 (an “Eligible
              Customer”).
            </li>
          </ul>
        </div>
      )
    },
    {
      content: (
        <Typography variant="body1">
          The Winner is responsible for making all finance repayments to the lender.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Each Prize will be transferred from Zuto directly to the Winner&apos;s bank account.
          Winners must confirm their bank details in order to claim their Prize.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Winners will be notified by email or telephone (using details provided during the
          application process) before 30 April 2026 and must provide bank account details to claim
          the Prize. If a Winner does not respond to Zuto within 5 days of being notified by Zuto,
          their Prize will be forfeited and Zuto will be entitled to select another Winner in
          accordance with the process described above.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Each Prize is non-transferable, non-negotiable, non-refundable and there is no
          alternative.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Insofar as is permitted by law, Zuto, its agents or distributors will not in any
          circumstances be responsible or liable to compensate the Winner or accept any liability
          for any loss, damage, personal injury or death occurring as a result of taking up the
          Prize except where it is caused by the negligence of Zuto, its agents or distributors or
          that of their employees. Your statutory rights are not affected.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Zuto accepts no responsibility for any errors (technical or human), or for any entries
          affected or invalidated by technical failures, faults or malfunctions or computer hardware
          or software failure, satellite, network or server failure of any kind, or for data
          corruption. Zuto accepts no responsibility for any incomplete or illegible entries, or
          entries that fail to be validly and/or properly submitted.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Personal data supplied by entrants by submitting a finance application during the course
          of this promotion will only be processed as set out in Zuto’s privacy policy{' '}
          <Link href="https://www.zuto.com/privacy/" target="_blank" rel="noreferrer">
            Privacy Policy
          </Link>
          . See also condition 17 with regard to the announcement of winners.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Zuto must either publish or make available information that indicates that a valid award
          took place. To comply with this obligation Zuto will send the surname of Winners to anyone
          who requests this (by emailing <Link href="mailto:crm@zuto.com">crm@zuto.com</Link>)
          within one month after 16 April 2026. If you object to any or all of your surname being
          published or made available, please contact crm@zuto.com. In such circumstances, Zuto must
          still provide the information and winning entry to the Advertising Standards Authority on
          request.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Zuto reserves the right to amend, vary, void, cancel, suspend or withdraw these terms and
          conditions or the Prize Draw at any time without prior notice where it becomes necessary
          to do so.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          Zuto&apos;s decision regarding any aspect of the Prize Draw is final and binding and no
          correspondence will be entered into about it.
        </Typography>
      )
    },
    {
      content: (
        <Typography variant="body1">
          The prize draw will be governed by English law and entrants to the prize draw submit to
          the jurisdiction of the English courts.
        </Typography>
      )
    }
  ]
}
